import React from 'react'
import { AppCrudTable } from '@components'
import { sitesColumn, numSearchesColumn, frequencyColumn, frequencyHoursColumn, nameColumn, officesColumn } from './@columns'
import { reportsHandlerTableData, isReportsHandlerLoading } from 'Pages/Admin/ReportsHandler/@signals'
import { Skeleton } from '@mui/material'
import ReportsHandlerSelectToolbar from 'Pages/Admin/ReportsHandler/Table/SelectToolbar'


export default function ReportsHandleTable() {

	if (isReportsHandlerLoading.value) {
		return <Skeleton variant='rectangular' height={500} />
	} else if (!reportsHandlerTableData.value.length) {
		return null
	}

	return <AppCrudTable
		data={reportsHandlerTableData.value}
		title="Users & Reports List"
		options={{
			selectableRows: 'multiple',
			customToolbarSelect: (selectedData, setSelectedRows) => <ReportsHandlerSelectToolbar
				selectedData={selectedData}
				setSelectedRows={setSelectedRows}/>
		}}
		columns={[nameColumn(), ...sitesColumn(), numSearchesColumn(), frequencyColumn(), frequencyHoursColumn(), ...officesColumn()  ]}
	/>
}